import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface DashboardStats {
  products: number;
  categories: number;
  orders: number;
  brands: number;
}

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  private http = inject(HttpClient);
   private get apiUrl(): string {
    const base = localStorage.getItem('apiURL');
    if (!base) throw new Error('apiURL not ready');
    return base + "/api/v2/dashboard" ;
  }
  getDashboardStats(): Observable<DashboardStats> {
    return this.http.get<DashboardStats>(`${this.apiUrl}/stats`);
  }

  getStatsWithTrends(): Observable<DashboardStats & {
    productsChange: number;
    categoriesChange: number;
    ordersChange: number;
    brandsChange: number;
  }> {
    return this.http.get<DashboardStats & {
      productsChange: number;
      categoriesChange: number;
      ordersChange: number;
      brandsChange: number;
    }>(`${this.apiUrl}/stats/detailed`);
  }
}